import * as React from "react";

import { NextStepModel } from "../Models/NextStepModel";

interface IQuestionStates {
    chosenAnswerId: string;
}

interface IQuestionProps {
    question: NextStepModel;
    setNextQuestionId: any;
}

export default class Question extends React.Component<IQuestionProps, IQuestionStates> {
    constructor(props: IQuestionProps) {
        super(props);

        this.state = {
            chosenAnswerId: null,
        };
    }

    public SetSelectedQuestionId(questionId: string, answerId: string) {
        this.setState({
            chosenAnswerId: answerId,
        });
        this.props.setNextQuestionId(questionId);
    }

    public render() {
        const answerHtml =
            this.props.question.answers.map((answer, i) => {
                return (
                    <div key={i} className="answer">
                        <p>
                            <input
                                onClick={(() => this.SetSelectedQuestionId(answer.nextQuestionId, answer.id))}
                                checked={this.state.chosenAnswerId === answer.id}
                                type="radio"
                                name="answer"
                                aria-label="answer"
                            />
                            <span
                                onClick={(() => this.SetSelectedQuestionId(answer.nextQuestionId, answer.id))}
                            >
                                {answer.text}
                            </span>
                        </p>
                    </div>
                );
            });

        return (
            <div className="question">
                <p className="question-text" dangerouslySetInnerHTML={{ __html: this.props.question.text }} />
                {answerHtml}
            </div>
        );
    }
}
